export const environment = {
  production: process.env['PRODUCTION'] === 'true',
  appURL: process.env['APP_URL'] || 'Entorno-no-definido',
  apiURL: process.env['API_URL'] || 'Entorno-no-definido',
  urlUpload: process.env['URL_UPLOAD'] || 'Entorno-no-definido',
  urlUploadShrn: process.env['URL_UPLOAD_SHRN'] || 'Entorno-no-definido',
  url_api_compre: process.env['URL_API_COMPRE'] || 'Entorno-no-definido',
  url_front_compre: process.env['URL_FRONT_COMPRE'] || 'Entorno-no-definido',
  url_front_regalias: process.env['URL_FRONT_REGALIAS'] || 'Entorno-no-definido',
  raiz_compre: process.env['RAIZ_COMPRE'] || 'Entorno-no-definido',
  dominio_compre: process.env['DOMINIO_COMPRE'] || 'Entorno-no-definido',
  version: process.env['VERSION'] || 'Entorno-no-definido',
  assets: "",

  //Variables PAGOS
  conceptos: {
    GUIA_TRANSPORTE: 2,
    REGALIAS: 3,
    APORTE_PROVINCIA: 4,
    APORTE_EDHIPSA: 5,
    APORTE_COMPROMISO: 6
  },
  subconceptos: {
    REGISTO_COMPRA_GUIAS: 3,
    ANEXO_I: 5,
    ANEXO_II: 6,
    RECTIFICATIVA: 7,
  }
};